<template>
  <div class="flex items-center">
    <span class="text-14 lg:text-20 font-600 select-none cursor-pointer" @click="$router.push({ name: 'project' })"> {{ $t('navigation.projects') }} </span>
    <span class="px-2 sm:px-4 font-600">|</span>
    <ProjectSelectDropdown :active-project="activeProject" :projects="projects" @click="onProjectSelect" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
      activeItem: null,
    };
  },
  computed: {
    ...mapState(['projects']),
    activeProject() {
      const activeProject = this.projects?.[this.$route.params.projectId] || {};
      return {
        projectId: this.$route.params.projectId,
        name: activeProject.name,
        icon: activeProject?.logos?.FAVICON || '',
      };
    },
  },
  created() {
    if (this.$route.params.projectId) {
      this.activeItem = this.$route.params.projectId;
    }
  },
  methods: {
    onProjectSelect(project) {
      this.$router.push({ name: this.$route.name, params: { projectId: project.id } });
      setTimeout(() => {
        window.location.reload();
      }, 50);
    },
  },
};
</script>
